import { gql } from '@apollo/client';

export const RemoveLapAccessMutation = gql`
    mutation RemoveLapAccess($id: ID!) {
        removeLapAccess(id: $id)
    }
`;
